module.exports = __webpack_public_path__ + "img/1sb-five-stars-orange-five_new_v1.8050f0f.svg";